module.exports = __webpack_public_path__ + "img/MadMix.25cb10bf.png";